/*
TreeMapStore provides a MST-friendly way to generate and display treemaps
Raw data is passed in along with settings, and a series of rectangles are generated using D3
*/
import {types} from "mobx-state-tree";

import {
    hierarchy,
    treemap,
    treemapSquarify,
    treemapResquarify,
} from 'd3-hierarchy';
import programElements from "../../assets/program-elements";

const Node = types
    .model('Node', {
        id: types.identifier,
        size: types.number,
        color: types.string,
        name: types.string,
        groups: types.array(types.string)
    }).actions(self => ({
        setSize(val) {
            self.size = val;
        }
    }));


export const TreeMapStore = types
    .model('TreeMapStore', {
        width: types.number,
        height: types.number,
        nodes: types.map(Node),
    })
    .volatile(self => ({
        treemapD3: treemap()
            .tile(treemapResquarify)
            // .round(true)
            .paddingOuter(2)
        // .paddingTop(15)
        // .paddingInner(2)
    }))
    .actions(self => ({
        setSize(width, height) {
            self.width = width;
            self.height = height;
            // console.log('setSize, width : ' + self.width);
        },
        addNode(node) {
            self.nodes.put(node);
        },
        setNodeSize(id, value) {
            self.nodes.get(id).setSize(value);
        },
    })).views(self => ({
        get treeRectangles() {
            self.treemapD3.size([self.width, self.height]);
            // console.log('Rectangle Getter called, width : ' + self.width);
            const topNode = {id: '_top_', children: []};
            const hierarchyLookup = {};//use efficient lookup by id since we can be looping over millions of items
            let parentGroup = topNode;
            for (let node of self.nodes.values()) {

                const groups = node.groups;
                parentGroup = topNode;
                groups.forEach((group, i) => {
                    const groupId = `${parentGroup.id}_${group}`;
                    if (!hierarchyLookup[groupId]) {
                        hierarchyLookup[groupId] = {id: groupId, children: [], value: 0, group: group};
                        parentGroup.children.push(hierarchyLookup[groupId]);
                    }
                    parentGroup = hierarchyLookup[groupId];
                });
                if (node.size > 0) {
                    parentGroup.children.push({id: node.id, value: node.size, color: node.color, name: node.name});
                }
                // parentGroup.value += node.size;
            }
            const root = hierarchy(topNode)
                .sum((d) => {
                    return d.value;
                });

            self.treemapD3(root);

            const rects = [];
            const genRects = (d) => {
                if (d.data && d.data.id) {

                }
                rects.push({
                    id: d.data.id,
                    label: d.data.name,
                    color: d.data.color,
                    x: d.x0,
                    y: d.y0,
                    width: d.x1 - d.x0,
                    height: d.y1 - d.y0
                });
                if (d.children) {
                    d.children.forEach((child, i) => {
                        genRects(child);
                    });
                }
            };

            genRects(root);
            return rects.filter((r) => r.width * r.height > 0 && r.color);
        }
    }));
const initProgramElements = (tmStore) => {
    programElements.forEach((group, i) => {
        group.elements.forEach((programElement, i) => {
            tmStore.addNode({
                id: programElement.id,
                name: programElement.name,
                size: 0,
                groups: [group.name],
                color: group.color
            });
        });
    });
};

export const treeMapStore = TreeMapStore.create({width: 400, height: 400, nodes: {}});
initProgramElements(treeMapStore);
export const treeMapResultsStore = TreeMapStore.create({width: 400, height: 400, nodes: {}});
initProgramElements(treeMapResultsStore);
